import {Component} from '@angular/core';
import {Router} from '@angular/router';
import { ToasterService} from 'angular2-toaster/angular2-toaster';
import {ClientsService} from "../../models/clients/clients.service";
import {dateTimeHelper} from "../../helpers/date";

@Component({
    selector: 'glob-livesearch',
    templateUrl: 'tpl.html',
    styleUrls: ['style.css']
})
export class GlobLiveSearchComponent
{
    model: any = false;

    searchError: any = false;

    searchStr: any;

    isLoading: any = false;

    message: any = false;

    is_opened: any = false;

    constructor(
        private service: ClientsService,
        private router: Router,
        private toasterService: ToasterService,
    ) {

    }

    ngOnInit() {

    }

    searchLoad(no_wait: any = false) {
        this.load({q: this.searchStr}, no_wait);
    }

    private _load_once: any = {};
    load(filter: any, no_wait: any = false) {

        if (true || ! no_wait) this.model = false;
        this._load_once = {};
        var _local_once = this._load_once;

        try {
            this.message = false;
            if (filter.q.trim().length <= 0) throw "x";
            //this.isLoading = true;
        } catch (e) {
            this.isLoading = false;
            this.close();
            return;
        }

        setTimeout(() => {
            if (this._load_once !== _local_once) return;

            if (true || ! no_wait) this.isLoading = true;
            this.is_opened = true;
            this.service.globalSearch(filter)
                .subscribe(
                    (res) => {
                        if (this._load_once !== _local_once) return;
                        this.isLoading = false;
                        this.message = false;
                        this.model = res.data;
                    },
                    (error) => {
                        if (this._load_once !== _local_once) return;

                        this.message = false;
                        this.model = false;
                        try {
                            if (error.status > 499.9 && error.status < 599.9) {
                                setTimeout(() => {
                                    this.searchLoad();
                                }, 500);
                                return;
                            }

                            this.isLoading = false;

                            if (error.status != 400) return;

                            let errorData = JSON.parse(error._body);
                            let errors: any = {};
                            for (var err of errorData.errors) {
                                for (var i in err) {
                                    if (! err.hasOwnProperty(i)) continue;
                                    errors[i] = err[i];
                                }
                            }
                            this.message = errors['message'];
                        } catch (e) {
                        }
                    });
        }, no_wait ? 4 : 400);
    }

    dateDisplayFormat(date) {
        try {
            return dateTimeHelper.dateFormatUSA(date, false) + ' ' + dateTimeHelper.get24Time(date, false);
        } catch (e) {
            return '';
        }
    }

    gotoEntity(entity: any) {
        if (! this.is_opened) return;

        if (! entity.url) {
            this.saveStatusWA(entity.id);
            return;
        }

        this.close();

        try {
            this.router.navigateByUrl('/leads').then(() => {
                this.router.navigateByUrl(entity.url);
            });
        } catch (e) {
        }
    }

    gotoUrl(url: any) {
        if (! this.is_opened) return;
        this.close();
        try {
            this.router.navigateByUrl('/leads').then(() => {
                this.router.navigateByUrl(url);
            });
        } catch (e) {
        }
    }

    close() {
        this.is_opened = false;
        this.searchStr = '';
    }

    private _changing_id: any = 0;
    saveStatusWA(id: any) {
        if (id == this._changing_id) return;
        this._changing_id = id;
        this.service.setStatus(id, {status: 10})
            .subscribe(res => {
                //if (! this.is_opened) return;
                if (id == this._changing_id) this._changing_id = 0;
                let message = res.data.message ? res.data.message : 'Status was changed';
                this.toasterService.pop('success', 'Success', message);
                if (! this.is_opened) return;
                this.searchLoad(true);
            }, (e) => {
                //if (! this.is_opened) return;
                if (id == this._changing_id) this._changing_id = 0;
                let errorData = JSON.parse(e._body);
                this.toasterService.pop('error', 'Error', errorData.message);
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/glob-search/component.ts